var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShopArtBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 26,
  fill: "none",
  viewBox: "0 0 24 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#494DCB",
  fillRule: "evenodd",
  d: "M6.947 2.675C6.12 3.733 5.695 4.94 5.574 5.831H3.65c-.866 0-1.585.671-1.644 1.536L.838 24.54a1.1 1.1 0 0 0 1.098 1.175h20.128a1.1 1.1 0 0 0 1.098-1.175L21.993 7.367a1.65 1.65 0 0 0-1.644-1.536H18.43c-.115-.94-.54-2.163-1.38-3.22C16.03 1.325 14.395.284 12 .284c-2.406 0-4.039 1.09-5.054 2.39m.946.739A5.75 5.75 0 0 0 6.788 5.83H17.22a5.5 5.5 0 0 0-1.109-2.474C15.3 2.335 14.001 1.485 12 1.485c-1.991 0-3.29.882-4.107 1.929M5.537 8.503V7.03H3.651a.45.45 0 0 0-.447.417l-.9 13.235h19.393l-.901-13.235a.45.45 0 0 0-.447-.417h-1.886v1.472a.6.6 0 1 1-1.2 0V7.03H6.737v1.472a.6.6 0 0 1-1.2 0m16.241 13.38H2.222l-.18 2.632h19.915z",
  clipRule: "evenodd"
})));
export { SvgShopArtBag as ReactComponent };